var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineIndicator2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 28,
    viewBox: "0 0 165 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 2.84741C1 2.84741 49.7635 -1.80109 85.025 4.41646C120.286 10.634 163.493 26.4994 163.493 26.4994",
    stroke: "#D9DBE1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "2 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineIndicator2);
export default __webpack_public_path__ + "static/media/line-indicator2.dc503b3ae572b3e439080617aeb3a0a1.svg";
export { ForwardRef as ReactComponent };